import Vue from 'vue'
import ElementUI from 'element-ui'
// Element UI原生CSS（无需适配路径）
import 'element-ui/lib/theme-chalk/index.css'

// 全局注册Element UI（Vue 2标准方式）
Vue.use(ElementUI)

// 导出空对象（保持导入习惯）
export default {}